module.exports = __webpack_public_path__ + "static/assets/1ed010e6b5800ef92dc247849c164aaf.jpg";